import React from 'react';
import { Link } from 'react-router-dom';
import logoWhite from '../assets/LinkedIn-Local-Cameroon-Logo-white.png';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__grid">
          <div className="footer__col">
            <img src={logoWhite} alt="LLC 2026" className="footer__logo" />
            <p className="footer__tagline">
              Cameroon's Biggest Professional Leadership Summit. Bridging the gap between academia and industry.
              Empowering youth for career growth, networking, and opportunities.
            </p>
            <div className="footer__social-row">
              <a href="https://www.linkedin.com/company/linkedin-local-cameroon/" className="footer__social-icon" target="_blank" rel="noreferrer">in</a>
              <a href="https://www.facebook.com/profile.php?id=61587542943056" className="footer__social-icon" target="_blank" rel="noreferrer">f</a>
              <a href="https://www.instagram.com/linkedinlocalcameroon?igsh=bm9oZDY4ZHM0cTM2" className="footer__social-icon" target="_blank" rel="noreferrer">ig</a>
            </div>
          </div>
          <div className="footer__col">
            <h4 className="footer__heading">Quick Links</h4>
            <ul className="footer__links">
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/speakers">Speakers</Link></li>
              <li><Link to="/tickets">Get Tickets</Link></li>
              <li><Link to="/gallery">Gallery</Link></li>
            </ul>
          </div>
          <div className="footer__col">
            <h4 className="footer__heading">Get Involved</h4>
            <ul className="footer__links">
              <li><Link to="/sponsors">Become a Sponsor</Link></li>
              <li><Link to="/awards">Apply for Award</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </ul>
          </div>
          <div className="footer__col">
            <h4 className="footer__heading">Contact</h4>
            <ul className="footer__links">
              <li>
                <span style={{ color: 'rgba(255,255,255,0.7)', fontSize: 14 }}>
                  Best Western Plus Hotel,<br />
                  Soaho Douala Airport,<br />
                  Cameroon
                </span>
              </li>
              <li style={{ marginTop: 10 }}>
                <a href="mailto:info@linkedinlocalcameroon.com" style={{ color: 'var(--yellow)' }}>
                  info@linkedinlocalcameroon.com
                </a>
              </li>
              <li>
                <a href="tel:+237000000000" style={{ color: 'var(--yellow)' }}>
                  +237 683 66 85 18
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="footer__bottom">
          <div className="footer__copy">
            &copy; {new Date().getFullYear()} LinkedIn Local Cameroon. All Rights Reserved.
          </div>
          <div style={{ fontSize: 12 }}>
            <Link to="/admin" style={{ color: 'rgba(255,255,255,0.3)', textDecoration: 'none' }} onMouseEnter={(e) => e.target.style.color = 'rgba(255,255,255,0.6)'} onMouseLeave={(e) => e.target.style.color = 'rgba(255,255,255,0.3)'}>
              Admin Area
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
